export default __webpack_public_path__ + "static/media/done.42eb226b.svg";